const MAX_CAPACITY = 1024;
export const DEFAULT_SPRITE_OPTIONS = {
    useCanvasAtlas: true,
    managerCapacity: 64,
};
function readFlag(params, name, fallback) {
    const value = params.get(name);
    if (value === null)
        return fallback;
    return value !== '0' && value.toLowerCase() !== 'false';
}
function readCapacity(params) {
    const raw = params.get('bunnycap');
    if (raw === null)
        return DEFAULT_SPRITE_OPTIONS.managerCapacity;
    const parsed = Number(raw);
    if (!Number.isInteger(parsed) || parsed < 1)
        return DEFAULT_SPRITE_OPTIONS.managerCapacity;
    return Math.min(parsed, MAX_CAPACITY);
}
export function spriteOptionsFromQuery(search) {
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    return {
        useCanvasAtlas: readFlag(params, 'bunnycanvas', DEFAULT_SPRITE_OPTIONS.useCanvasAtlas),
        managerCapacity: readCapacity(params),
    };
}
export function describeSpriteOptions(options) {
    const overrides = [];
    if (!options.useCanvasAtlas)
        overrides.push('network atlas');
    if (options.managerCapacity !== DEFAULT_SPRITE_OPTIONS.managerCapacity) {
        overrides.push(`capacity ${options.managerCapacity}`);
    }
    return overrides.length ? overrides.join(', ') : 'defaults';
}
